import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'td-wb-side-sheet-selector-toggle-static'
})
export class SideSheetSelectorToggleStaticDirective {
}
